<div
  class="action-card"
  [class.action-card--disabled]="disabled()"
  (click)="onClick()"
  (keydown)="onKeyDown($event)"
  [attr.role]="'button'"
  [attr.tabindex]="disabled() ? -1 : 0"
  [attr.aria-disabled]="disabled()">

  <div class="action-card__icon-container">
    @if (iconType() === 'material') {
      <mat-icon class="action-card__icon">{{ icon() }}</mat-icon>
    } @else if (iconType() === 'component' && iconName()) {
      <app-icon
        [name]="iconName()!"
        [size]="iconSize()"
        [color]="iconColor()"
        class="action-card__icon action-card__icon--component" />
    } @else {
      <img
        [src]="icon()"
        [alt]="title()"
        class="action-card__icon action-card__icon--svg" />
    }
  </div>

  <div class="action-card__content">
    <p class="action-card__title">{{ title() }}</p>
    <p class="action-card__subtitle">{{ subtitle() }}</p>
  </div>
</div>
